module.exports = __webpack_public_path__ + "img/home_img_banner.752e2edf.png";